import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'
import { Button, Card, CardActions, CardContent, CardMedia, Grid, Link, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import Big from 'big.js'
import React, { useState } from 'react'
import nl2br from 'react-nl2br'

const useStyles = makeStyles((theme) => ({
    card: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    cardMedia: {
        // height: '100%',
    },
    cardContent: {
        flexGrow: 1,
    },
    cardActions: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    moreInfoLink: {
        flexShrink: 0,
    },
}))

export default function PackageCard(props) {
    const { package: pkg } = props
    const classes = useStyles()
    const [imgErrored, setImgErrored] = useState(false)
    const [descriptionExpanded, setDescriptionExpanded] = useState(false)

    function handleAddToCart() {
        props.onAddToCart(pkg)
    }

    function handleImgError(e) {
        if (!imgErrored) {
            setImgErrored(true)
            e.target.src = '/product_imgs/missing_image_square.jpg'
        }
    }

    const subtotal = pkg.paid_on_purchase == pkg.price ? Big(pkg.lines.reduce((sum, line) => sum.plus(line.product_total), Big(0))) : Big(pkg.paid_on_purchase)

    let price = <>${Number(subtotal).toFixed(2)}</>

    if (pkg.price != pkg.paid_on_purchase) {
        price = <>
            ${Number(subtotal).toFixed(2)} total<br />
            ${Number(pkg.paid_on_purchase).toFixed(2)} up-front
        </>
    }

    const productNames = pkg.lines.map(line => {
        let format_name

        if (line.upc_code == line.product.upc_code) {
            format_name = line.product.individual_format?.format_name
        }

        if (line.upc_code == line.product.bulk_upc_code) {
            format_name = line.product.bulk_format?.format_name
        }

        return format_name ? `${line.product.name} (${format_name}) x ${line.product_quantity}` : `${line.product.name} x ${line.product_quantity}`
    })

    let descriptionWithProducts = [
        pkg.description,
        '',
        ...productNames,
    ].join('\n')

    return (
        <Card className={classes.card}>
            <CardMedia
                className={classes.cardMedia}
                title={pkg.name}
                component="img"
                onError={handleImgError}
                image={pkg.image_url || window.location.origin + '/product_imgs/missing_image_square.jpg' }
            />
            <CardContent className={classes.cardContent}>
                <Typography gutterBottom variant="h5">
                    {pkg.name}
                </Typography>
                <Grid container justifyContent="space-between" wrap="wrap">
                    <Typography variant="body2" color="textSecondary" noWrap={!descriptionExpanded}>
                        {(pkg.description && descriptionExpanded ? nl2br(descriptionWithProducts) : pkg.description) || 'No information provided'}
                        {descriptionExpanded && <>
                            <br />
                            <br />
                        </>}
                        {descriptionExpanded &&
                            <Link
                                component="button"
                                variant="body2"
                                color="primary"
                                onClick={() => { setDescriptionExpanded(false) }}
                                underline="hover"
                            >

                                Less Info
                            </Link>
                        }
                    </Typography>
                    {pkg.description && !descriptionExpanded &&
                        <Link
                            className={classes.moreInfoLink}
                            variant="body2"
                            component="button"
                            color="primary"
                            onClick={() => { setDescriptionExpanded(true) }}
                            underline="hover"
                        >
                            More Info
                        </Link>
                    }
                </Grid>
            </CardContent>
            <CardActions className={classes.cardActions}>
                <Typography>{price}</Typography>
                <Button size="small" color="primary" startIcon={<AddShoppingCartIcon />} onClick={handleAddToCart}>
                    Add to Cart
                </Button>
            </CardActions>
        </Card>
    )
}
